import React, { useState, useEffect } from "react";
import { BiPlusMedical } from "react-icons/bi";
import { useForm } from "react-hook-form";
import Contacto from "./contacto";
import "./escalamiento.css";

export const Escalamiento = ({
  remover,
  setFormData,
  handleRangeScale,
  handleTries,
  handleFullNameScaleChange,
  handleMailScale,
  index,
  data,
  formData,
}) => {
  const [contact, setContact] = useState(0);
  const [rangeScaleValue, setRangeScaleValue] = useState("");
  const [triesValue, setTriesValue] = useState("");
  const [fullNameValue, setFullNameValue] = useState("");
  const [mailValue, setMailValue] = useState("");

  index += 1;

  useEffect(() => {
    setContact(formData.full_nameScale[index].length - 1);
    setRangeScaleValue(formData.range_scale[index] || "");
    setTriesValue(formData.tries[index] || "");
    setFullNameValue(
      formData.full_nameScale[index] ? formData.full_nameScale[index][0] : ""
    );
    setMailValue(formData.mailScale[index] ? formData.mailScale[index][0] : "");
  }, [remover, formData, index]);

  const {
    register,
    formState: { errors },
  } = useForm();

  const addContact = () => {
    setContact((prevContact) => prevContact + 1);
  };

  const removeContact = (index, indexArray) => {
    const restructureArray = (arr) => {
      return arr.filter((_, idx) => idx !== indexArray);
    };

    setFormData((prevFormData) => {
      const newFormData = { ...prevFormData };

      if (
        newFormData.full_nameScale[index] &&
        Array.isArray(newFormData.full_nameScale[index])
      ) {
        newFormData.full_nameScale[index] = restructureArray(
          newFormData.full_nameScale[index]
        );
      }

      if (
        newFormData.mailScale[index] &&
        Array.isArray(newFormData.mailScale[index])
      ) {
        newFormData.mailScale[index] = restructureArray(
          newFormData.mailScale[index]
        );
      }

      return newFormData;
    });

    setContact((prev) => (prev > 0 ? prev - 1 : 0));
  };

  return (
    <>
      <tr>
        {/* Rango */}
        <td>
          <div className="form-group row">
            <div className="col-sm-12">
              <input
                type="number"
                className="form-control range_scale"
                placeholder="Rango pruebas"
                id="range_scale"
                name="range_scale"
                value={rangeScaleValue}
                min="1"
                onChange={(e) => handleRangeScale(index, e.target.value)}
              />
            </div>
          </div>
        </td>

        {/* Intentos */}
        <td>
          <div className="form-group row">
            <div className="col-sm-12">
              <input
                type="number"
                className="form-control tries"
                placeholder="Intentos"
                id="tries"
                name="tries"
                value={triesValue}
                min="1"
                onChange={(e) => handleTries(index, e.target.value)}
              />
            </div>
          </div>
        </td>

        {/* Contactos */}
        <td colspan="2" className="pr-0 m-0 text-center">
          <table className="table table-borderless">
            <thead>
              <tr>
                <th
                  className="text-center"
                  style={{
                    width: "50%",
                    height: "50%",
                    maxWidth: "50%",
                    minWidth: "50%",
                  }}
                >
                  Nombre
                </th>
                <th
                  className="text-center"
                  style={{
                    width: "50%",
                    height: "50%",
                    maxWidth: "50%",
                    minWidth: "50%",
                  }}
                >
                  Correo
                </th>
              </tr>
            </thead>
            <tbody className="contactsScale">
              <tr>
                <td>
                  {/* nombre completo */}
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      id="full_nameScale"
                      name="full_nameScale"
                      value={fullNameValue}
                      placeholder="Nombre completo"
                      {...register("full_nameScale", {
                        pattern: {
                          value: /^[a-zA-ZáéíóúÁÉÍÓÚüÜñÑ\s]+$/,
                          message: "Ingresa un Nombre valido",
                        },
                        maxLength: 255,
                        minLength: 3,
                      })}
                      onChange={(e) =>
                        handleFullNameScaleChange(index, 0, e.target.value)
                      }
                    />
                    {errors.full_nameScale?.type === "pattern" && (
                      <small
                        className="help-block"
                        data-fv-validator="notEmpty"
                        data-fv-for="full_nameScale"
                        data-fv-result="INVALID"
                      >
                        {errors.full_nameScale.message}
                      </small>
                    )}

                    {errors.full_nameScale?.type === "minLength" && (
                      <small
                        className="help-block"
                        data-fv-validator="notEmpty"
                        data-fv-for="full_nameScale"
                        data-fv-result="INVALID"
                      >
                        Por favor introduce un valor con una longitud entre 3 y
                        255 caracteres
                      </small>
                    )}
                    {errors.full_nameScale?.type === "maxLength" && (
                      <small
                        className="help-block"
                        data-fv-validator="notEmpty"
                        data-fv-for="full_nameScale"
                        data-fv-result="INVALID"
                      >
                        Por favor introduce un valor con una longitud entre 3 y
                        255 caracteres
                      </small>
                    )}
                  </div>
                </td>
                <td>
                  {/* Correo */}
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      id="mailScale"
                      name="mailScale"
                      value={mailValue}
                      placeholder="Correo"
                      {...register("mailScale", {
                        pattern: {
                          value:
                            /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                          message:
                            "Por favor introduce un correo electrónico válido",
                        },
                      })}
                      onChange={(e) =>
                        handleMailScale(index, 0, e.target.value)
                      }
                    />
                    {errors.mailScale?.type === "pattern" && (
                      <small
                        className="help-block"
                        data-fv-validator="notEmpty"
                        data-fv-for="mailScale"
                        data-fv-result="INVALID"
                      >
                        {errors.mailScale.message}
                      </small>
                    )}

                    {errors.mailScale?.type === "minLength" && (
                      <small
                        className="help-block"
                        data-fv-validator="notEmpty"
                        data-fv-for="mailScale"
                        data-fv-result="INVALID"
                      >
                        Por favor introduce un valor con una longitud entre 3 y
                        255 caracteres
                      </small>
                    )}
                    {errors.mailScale?.type === "maxLength" && (
                      <small
                        className="help-block"
                        data-fv-validator="notEmpty"
                        data-fv-for="mailScale"
                        data-fv-result="INVALID"
                      >
                        Por favor introduce un valor con una longitud entre 3 y
                        255 caracteres
                      </small>
                    )}
                  </div>
                </td>
              </tr>
              {Array.from({ length: contact }).map((_, indexC) => (
                <>
                  <Contacto
                    key={indexC}
                    index={index}
                    indexArray={indexC}
                    remover={removeContact}
                    handleFullNameScaleChange={handleFullNameScaleChange}
                    handleMailScale={handleMailScale}
                    data={data}
                    formData={formData}
                  />
                </>
              ))}
            </tbody>
            <tbody>
              <tr>
                <td colSpan={3}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <button
                      style={{
                        backgroundColor: "#28a745",
                        color: "white",
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        marginRight: "10px",
                      }}
                      type="button"
                      id="agregar2"
                      onClick={addContact}
                    >
                      <BiPlusMedical />
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </td>

        {/* Boton eliminar */}
        <td>
          <svg
            class="svg-inline--fa fa-trash fa-w-14 text-danger deleteIcon"
            onClick={() => {
              remover(index);
            }}
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="trash"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
            data-fa-i2svg=""
          >
            <path
              fill="currentColor"
              d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"
            ></path>
          </svg>{" "}
        </td>
      </tr>
    </>
  );
};
